import * as React from 'react';
import { Button } from '@cian/button-component';
import { mergeStyles } from '@cian/utils';
import { useFormikContext } from 'formik';
import { IFormValues } from '../DealRentModal';
import { trackSafeRentFormSend } from '../../../store/deal-rent/tracking';
import * as styles from '../index.css';

export interface IDealRentModalProps {
  isLoading: boolean;
}

export const Submit = ({ isLoading }: IDealRentModalProps) => {
  const { submitForm } = useFormikContext<IFormValues>();
  const submit = React.useCallback(() => {
    trackSafeRentFormSend();
    submitForm();
  }, [submitForm, trackSafeRentFormSend]);

  return (
    <div {...mergeStyles(styles['submit'])}>
      <Button type="submit" disabled={isLoading} isSync={isLoading} onClick={submit}>
        Отправить анкету
      </Button>
    </div>
  );
};
